
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/react-19-cheatsheet",
      function () {
        return require("private-next-pages/react-19-cheatsheet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/react-19-cheatsheet"])
      });
    }
  